const React = require('react')
const { useState } = require('react')
const { FormGroup, Label, FormFeedback, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const VerifyContractFormGroup = ({ type, label, value, setValue, errors, setErrors, options }) => {
    const { network } = useNetworkConfig()
    const [dropdownOpen, setDropdownOpen] = useState(false)

    const handleValueChange = selectedValue => {
        if (selectedValue === value) {
            setDropdownOpen(false)
        } else if (selectedValue === 'Please Select') {
            setValue(selectedValue)
            setErrors(prev => ({
                ...prev,
                [type]: 'Required'
            }))
        } else {
            setValue(selectedValue)
            setErrors(prev => ({
                ...prev,
                [type]: ''
            }))
        }
    }

    return (
        <FormGroup>
            <Label>{label}</Label>
            <Dropdown
                isOpen={dropdownOpen}
                toggle={() => setDropdownOpen(!dropdownOpen)}
                className='mb-3 w-100 dark-dropdown'
                invalid={!!errors[type]}
            >
                <DropdownToggle caret className='form-dropdown-toggle'>
                    {value}
                </DropdownToggle>
                <DropdownMenu className='w-100' style={{ overflowY: 'auto', maxHeight: '250px', padding: '0px' }}>
                    {Object.keys(options).map(option => (
                        <DropdownItem
                            className={`${network.name}-dropdown-item`}
                            key={option}
                            onClick={() => handleValueChange(option)}
                        >
                            {option}
                        </DropdownItem>
                    ))}
                </DropdownMenu>
            </Dropdown>
            {errors[type] && <FormFeedback style={{ display: 'block' }}>{errors[type]}</FormFeedback>}
        </FormGroup>
    )
}

module.exports = { VerifyContractFormGroup }
